// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { arrowInCircle16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-arrow-in-circle': IconArrowInCircle;
    }
}

/**
 * The icon component for the 'arrowInCircle' icon
 */
export class IconArrowInCircle extends IconSvg {
    public constructor() {
        super(arrowInCircle16X16);
    }
}

registerIconSvg('icon-arrow-in-circle', IconArrowInCircle);
export const iconArrowInCircleTag = 'nimble-icon-arrow-in-circle';
